<template>
	<b-card id="translations-card" no-body>
		<b-overlay :show="loading" no-wrap></b-overlay>
		<b-tabs card v-if="translatableValues !== null">
			<b-tab
				v-for="(langOpt, i) in $root.auxVars.langOpts"
				:key="langOpt.value"
				:title="langOpt.text"
				:active="i === 0"
			>
				<b-row>
					<b-col
						:cols="fieldData.col || 4"
						v-for="(fieldData, i) in translatableFields"
						:key="i"
					>
						<b-form-group :label="fieldData.label">
							<b-form-input
								v-if="fieldData.type === 'inputText'"
								type="text"
								size="sm"
								v-model="
									translatableValues[fieldData.field][
										langOpt.value
									]
								"
							/>
							<b-textarea
								v-if="fieldData.type === 'textarea'"
								size="sm"
								v-model="
									translatableValues[fieldData.field][
										langOpt.value
									]
								"
							/>
							<quillEditor
								:options="editorOptions"
								v-if="fieldData.type === 'texteditor'"
								size="sm"
								v-model="
									translatableValues[fieldData.field][
										langOpt.value
									]
								"
							>
							</quillEditor>
						</b-form-group>
					</b-col>
				</b-row>
			</b-tab>
		</b-tabs>
		<div class="text-right mr-2 mb-2">
			<b-button :disabled="unableEdit" @click="updateTranslations" variant="primary"
				>Guardar</b-button
			>
		</div>
	</b-card>
</template>

<script>
// import MainLayout from '../layout/MainLayout.vue'
// import api from '../../../api.js'
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";
export default {
	props: {
		unableEdit: Boolean,
		modelId: {
			type: Number,
			required: true
		},
		modelReference: {
			type: String,
			required: true
		},
		translatableFields: {
			type: Array,
			required: true
		}
	},
	components: {
		quillEditor
	},
	data() {
		// const translatableValues = {}
		return {
			loading: true,
			translatableValues: null,
			editorOptions: {
				theme: "snow",
				boundary: document.body,
				modules: {
					toolbar: [
						["bold", "italic", "underline", "strike"],
						[{ list: "ordered" }, { list: "bullet" }],
						[{ align: [] }],
						['link'],
						["clean"]
					]
				}
			}
		};
	},
	computed: {
		langOptsBase() {
			const base = {};
			this.$root.auxVars.langOpts.forEach(langInfo => {
				base[langInfo.value] = "";
			});
			return base;
		},
		translatableInputFields() {
			return this.translatableFields.filter(
				fieldData => fieldData.type == "inputText"
			);
		},
		translatableTextareaFields() {
			return this.translatableFields.filter(
				fieldData => fieldData.type == "textarea"
			);
		}
	},
	methods: {
		updateTranslations() {
			this.$root.api
				.put(`translations/${this.modelReference}/${this.modelId}`, {
					translations: this.translatableValues
				})
				.then(() => {
					this.$root.showAlert("Campos actualizados");
					this.loadTranslations();
				})
				.catch(this.$root.handleRequestError)
				.then(() => {
					this.loading = false;
				});
		},
		initTranslatableValues() {
			const base = { ...this.langOptsBase };
			this.translatableValues = {};
			this.translatableFields.forEach(tField => {
				this.translatableValues[tField.field] = { ...base };
			});
		},
		loadTranslations() {
			this.$root.api
				.get(`translations/${this.modelReference}/${this.modelId}`)
				.then(res => {
					this.translatableValues = { ...res.data };
				})
				.catch(this.$root.handleRequestError)
				.then(() => {
					this.loading = false;
				});
		}
	},
	mounted() {
		this.initTranslatableValues();
		this.loadTranslations();
	}
};
</script>

<style scoped>
#translations-card {
	min-height: 200px;
}
</style>
